import React from 'react'
import './Footer.css'
import Logo from '../../assets/images/SVG/logo-outline.svg';
import Blob from '../../assets/images/SVG/blob.svg';
import GitHubLogo from '../../assets/images/SVG/github-logo.svg';
import TwitterLogo from '../../assets/images/SVG/twitter-logo.svg';
import InstagramLogo from '../../assets/images/SVG/instagram-logo.svg';
import LinkedInLogo from '../../assets/images/SVG/linkedin-logo.svg';
import styled from  'styled-components';

const FooterBottom = styled.div`

`

function Footer() {
  return (
    <div className='footer'>
        <div className='footer-container'>
            <div className="top-footer-section">
                <div className="footer-top-section-container">
                    <img className='footer-img' src={Logo} />
                </div>
                <div className="footer-top-section-container">
                    <h2>Resources</h2>
                    <p>Telem partners</p>
                    <p>Documentation</p>
                    <p>Service Health</p>
                </div>
                <div className="footer-top-section-container">
                    <h2>Legal</h2>
                    <p>Privacy policy</p>
                    <p>Terms of service</p>
                </div>
                <div className="footer-top-section-container">
                    <h2>Company</h2>
                    <p>Blog</p>
                    <p>Contact Us</p>
                </div>
            </div>
            <div className="bottom-footer-section">
                <div className="footer-bottom-section-container footer-icon-container">
                    <img src={GitHubLogo} alt="" />
                    <img src={TwitterLogo} alt="" />
                    <img src={LinkedInLogo} alt="" />
                    <img src={InstagramLogo} alt="" />
                </div>
            </div>
        </div>
    </div>
  )
}

export default Footer